import { Headset } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { SUPPORT_CONTACT, isIntroPath } from "../../config/appConfig";
import "./SupportContact.css";

// WhatsApp support card, rendered above the footer on every page except the intro slides.
const SupportContact = () => {
  const { pathname } = useLocation();

  if (isIntroPath(pathname)) return null;

  return (
    <aside className="support-contact" aria-labelledby="support-contact-title">
      <div className="support-contact__card">
        <span className="support-contact__icon" aria-hidden="true">
          <Headset size={28} strokeWidth={2} />
        </span>

        <div className="support-contact__text">
          <h2 id="support-contact-title" className="support-contact__title">
            Need Help or Support?
          </h2>
          <p className="support-contact__tagline">Our team is here to assist you!</p>
          <p className="support-contact__body">
            For any questions or assistance, please contact us via WhatsApp:
          </p>
        </div>

        <a
          className="support-contact__whatsapp"
          href={SUPPORT_CONTACT.WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Contact us on WhatsApp at ${SUPPORT_CONTACT.WHATSAPP_NUMBER}`}
        >
          <span className="support-contact__whatsapp-icon" aria-hidden="true">
            <FaWhatsapp />
          </span>
          <span className="support-contact__number" dir="ltr">
            {SUPPORT_CONTACT.WHATSAPP_NUMBER}
          </span>
        </a>
      </div>
    </aside>
  );
};

export default SupportContact;
